





















import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { VueEditor } from "vue2-editor";
import { ILocale } from "@/@types/locale";

@Component({
  components: { VueEditor },
  inheritAttrs: false,
})
class MultilangInput extends Vue {
  @Prop({ type: Object, default: () => ({}) }) value!: ILocale;
  @Prop({ type: String, default: "" }) locale!: string;
  @Prop({ type: String, default: "" }) label!: string;
  @Prop({ type: String, default: "input" }) type!:
    | "input"
    | "textarea"
    | "editor";
  @Prop({ type: Boolean, default: false }) bare!: boolean;

  activeValue = "";

  @Watch("locale", { immediate: true })
  onLocaleChange(): void {
    this.activeValue = this.value?.[this.locale] ?? "";
  }

  @Watch("value", { deep: true })
  onValueChange(): void {
    const current = this.value?.[this.locale] ?? "";
    if (current !== this.activeValue) {
      this.activeValue = current;
    }
  }

  onInput(val: string): void {
    this.activeValue = val;
    const updated = { ...this.value, [this.locale]: val };
    this.$emit("input", updated);
  }
}

export default MultilangInput;
